// Renders the Noium wordmark inline so dark-mode renderings can swap only the
// letter fills to white while preserving the brand gradient on the bar below
// the "N". A flat CSS filter (the old approach) wiped that gradient out.
//
// The path data is preserved verbatim from /assets/logo.svg — including the
// outer translate(-160, -185) on the wrapping group — so positions match the
// canonical asset 1:1.
export function NoiumWordmark({
  dark = false,
  compact = false,
}: {
  dark?: boolean;
  compact?: boolean;
}) {
  const height = compact ? 22 : 28;
  const letterFill = dark ? "#FFFFFF" : "#000000";
  return (
    <svg
      role="img"
      aria-label="noium"
      viewBox="0 0 679 197"
      height={height}
      style={{ height, width: "auto", display: "block" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="noium-wordmark-gradient"
          x1="54.2223683%"
          y1="100%"
          x2="45.7776317%"
          y2="-7.61519295e-15%"
        >
          <stop stopColor="#0074ED" offset="0%" />
          <stop stopColor="#00FCCB" offset="100%" />
        </linearGradient>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-160, -185)" fillRule="nonzero">
          <g transform="translate(160.5, 185)">
            <path
              fill={letterFill}
              d="M198.38743,131 C179.175422,131 164.391182,125.271793 154.034709,113.81538 C143.678236,102.358966 138.5,86.438502 138.5,66.053987 C138.5,56.2567782 139.888368,47.3681815 142.665103,39.3881969 C145.441839,31.4082124 149.344278,24.5738691 154.37242,18.8851673 C159.400563,13.1964654 165.629456,8.89043411 173.059099,5.96707343 C180.488743,3.04371274 188.93152,1.5820324 198.38743,1.5820324 C207.693246,1.5820324 216.060976,3.04371274 223.490619,5.96707343 C230.920263,8.89043411 237.224203,13.1964654 242.402439,18.8851673 C247.580675,24.5738691 251.558161,31.4082124 254.334897,39.3881969 C257.111632,47.3681815 258.5,56.2567782 258.5,66.053987 C258.5,86.5965215 253.28424,102.556491 242.85272,113.933894 C232.421201,125.311298 217.599437,131 198.38743,131 Z M199.22619,31.6792342 C189.424603,31.6792342 182.186508,34.9644203 177.511905,41.5347924 C172.837302,48.1051646 170.5,56.3181299 170.5,66.1736881 C170.5,76.1856838 172.837302,84.4768678 177.511905,91.04724 C182.186508,97.6176121 189.424603,100.902798 199.22619,100.902798 C209.027778,100.902798 216.190476,97.6176121 220.714286,91.04724 C225.238095,84.4768678 227.5,76.1856838 227.5,66.1736881 C227.5,56.3181299 225.238095,48.1051646 220.714286,41.5347924 C216.190476,34.9644203 209.027778,31.6792342 199.22619,31.6792342 Z"
            />
            <path
              fill={letterFill}
              d="M308.011095,129.086127 L286.188975,129.086127 C282.875266,129.086127 280.188975,126.399835 280.188975,123.086127 L280.188975,9.00972018 C280.188975,5.69601168 282.875266,3.00972018 286.188975,3.00972018 L308.011095,3.00972018 C311.324804,3.00972018 314.011095,5.69601168 314.011095,9.00972018 L314.011095,123.086127 C314.011095,126.399835 311.324804,129.086127 308.011095,129.086127 Z"
            />
            <path
              fill="url(#noium-wordmark-gradient)"
              transform="translate(58.5, 179.5) rotate(90) translate(-58.5, -179.5)"
              d="M69.5,238 L47.5,238 C44.1862915,238 41.5,235.313708 41.5,232 L41.5,127 C41.5,123.686292 44.1862915,121 47.5,121 L69.5,121 C72.8137085,121 75.5,123.686292 75.5,127 L75.5,232 C75.5,235.313708 72.8137085,238 69.5,238 Z"
            />
            <path
              fill={letterFill}
              d="M397.845192,101.095729 C407.120289,101.095729 413.676823,98.663515 417.514794,93.7990869 C421.352765,88.9346588 423.111835,81.9569956 422.792004,72.8660972 L422.792004,9.00972018 C422.792004,5.69601168 425.478296,3.00972018 428.792004,3.00972018 L450.614125,3.00972018 C453.927833,3.00972018 456.614125,5.69601168 456.614125,9.00972018 L456.614125,73.8230339 L456.614125,73.8230339 C456.614125,82.5949534 455.774569,90.0909573 454.095456,96.3110457 C452.416344,102.531134 449.577844,108.193009 445.579958,113.296672 C442.541564,117.124418 439.223318,120.074973 435.62522,122.148336 C432.027122,124.221699 428.189151,125.93621 424.111307,127.29187 C420.033462,128.647531 415.715745,129.604467 411.158154,130.16268 C406.600564,130.720893 402.162909,131 397.845192,131 C387.930433,131 378.89521,129.64434 370.739521,126.933019 C362.583832,124.221699 355.787425,119.676249 350.350299,113.296672 C346.192497,108.193009 343.314019,102.531134 341.714864,96.3110457 C340.11571,90.0909573 339.316132,82.5949534 339.316132,73.8230339 L339.316132,9.00972018 C339.316132,5.69601168 342.002424,3.00972018 345.316132,3.00972018 L367.138253,3.00972018 C370.451961,3.00972018 373.138253,5.69601168 373.138253,9.00972018 L373.138253,72.8660972 L373.138253,72.8660972 C372.978337,81.9569956 374.897323,88.8947865 378.89521,93.6794698 C382.893096,98.4641532 389.209757,100.93624 397.845192,101.095729 Z"
            />
            <path
              fill={letterFill}
              transform="translate(59.149, 63.9951) rotate(180) translate(-59.149, -63.9951)"
              d="M59.0290595,98.0860088 C68.3041564,98.0860088 74.8606904,95.6537948 78.6986615,90.7893667 C82.5366326,85.9249386 84.2957027,78.9472754 83.9758718,69.856377 L83.9758718,6 C83.9758718,2.6862915 86.6621633,6.83009205e-13 89.9758718,6.83009205e-13 L111.797992,6.81232848e-13 C115.111701,6.86561918e-13 117.797992,2.6862915 117.797992,6 L117.797992,70.8133137 L117.797992,70.8133137 C117.797992,79.5852332 116.958436,87.0812371 115.279324,93.3013255 C113.600211,99.5214138 110.761712,105.183289 106.763825,110.286951 C103.725431,114.114698 100.407186,117.065253 96.8090877,119.138616 C93.2109898,121.211978 89.3730187,122.92649 85.2951744,124.28215 C81.21733,125.637811 76.8996125,126.594747 72.3420218,127.15296 C67.7844311,127.711173 63.346777,127.99028 59.0290595,127.99028 C49.1143008,127.99028 40.0790771,126.63462 31.9233885,123.923299 C23.7676999,121.211978 16.9712927,116.666529 11.534167,110.286951 C7.37636492,105.183289 4.49788658,99.5214138 2.89873195,93.3013255 C1.29957732,87.0812371 0.5,79.5852332 0.5,70.8133137 L0.5,6 C0.5,2.6862915 3.1862915,6.81232848e-13 6.5,6.81232848e-13 L28.3221205,6.82121026e-13 C31.635829,6.81232848e-13 34.3221205,2.6862915 34.3221205,6 L34.3221205,69.856377 L34.3221205,69.856377 C34.162205,78.9472754 36.0811906,85.8850663 40.0790771,90.6697496 C44.0769637,95.454433 50.3936245,97.9265194 59.0290595,98.0860088 Z"
            />
            <g transform="translate(477.2464, 0)" fill={letterFill}>
              <path d="M58.5290595,98.0860088 C67.8041564,98.0860088 74.3606904,95.6537948 78.1986615,90.7893667 C82.0366326,85.9249386 83.7957027,78.9472754 83.4758718,69.856377 L83.4758718,6 C83.4758718,2.6862915 86.1621633,8.8817842e-16 89.4758718,8.8817842e-16 L111.297992,-8.8817842e-16 C114.611701,-1.0658141e-14 117.297992,2.6862915 117.297992,6 L117.297992,70.8133137 L117.297992,70.8133137 C117.297992,79.5852332 116.458436,87.0812371 114.779324,93.3013255 C113.100211,99.5214138 110.261712,105.183289 106.263825,110.286951 C103.225431,114.114698 99.9071856,117.065253 96.3090877,119.138616 C92.7109898,121.211978 88.8730187,122.92649 84.7951744,124.28215 C80.71733,125.637811 76.3996125,126.594747 71.8420218,127.15296 C67.2844311,127.711173 62.846777,127.99028 58.5290595,127.99028 C48.6143008,127.99028 39.5790771,126.63462 31.4233885,123.923299 C23.2676999,121.211978 16.4712927,116.666529 11.034167,110.286951 C6.87636492,105.183289 3.99788658,99.5214138 2.39873195,93.3013255 C0.799577316,87.0812371 0,79.5852332 0,70.8133137 L0,6 C0,2.6862915 2.6862915,-8.8817842e-16 6,-8.8817842e-16 L27.8221205,0 C31.135829,-8.8817842e-16 33.8221205,2.6862915 33.8221205,6 L33.8221205,69.856377 L33.8221205,69.856377 C33.662205,78.9472754 35.5811906,85.8850663 39.5790771,90.6697496 C43.5769637,95.454433 49.8936245,97.9265194 58.5290595,98.0860088 Z" transform="translate(58.649, 63.9951) rotate(180) translate(-58.649, -63.9951)" />
              <path d="M142.484678,98.0860088 C151.759775,98.0860088 158.316309,95.6537948 162.15428,90.7893667 C165.992251,85.9249386 167.751321,78.9472754 167.43149,69.856377 L167.43149,6 C167.43149,2.6862915 170.117781,8.8817842e-16 173.43149,8.8817842e-16 L195.25361,-8.8817842e-16 C198.567319,-1.0658141e-14 201.25361,2.6862915 201.25361,6 L201.25361,70.8133137 L201.25361,70.8133137 C201.25361,79.5852332 200.414054,87.0812371 198.734942,93.3013255 C197.05583,99.5214138 194.21733,105.183289 190.219443,110.286951 C187.18105,114.114698 183.862804,117.065253 180.264706,119.138616 C176.666608,121.211978 172.828637,122.92649 168.750793,124.28215 C164.672948,125.637811 160.355231,126.594747 155.79764,127.15296 C151.240049,127.711173 146.802395,127.99028 142.484678,127.99028 C132.569919,127.99028 123.534695,126.63462 115.379007,123.923299 C107.223318,121.211978 100.426911,116.666529 94.9897851,110.286951 C90.8319831,105.183289 87.9535048,99.5214138 86.3543501,93.3013255 C84.7551955,87.0812371 83.9556182,79.5852332 83.9556182,70.8133137 L83.9556182,6 C83.9556182,2.6862915 86.6419097,-8.8817842e-16 89.9556182,-8.8817842e-16 L111.777739,0 C115.091447,-8.8817842e-16 117.777739,2.6862915 117.777739,6 L117.777739,69.856377 L117.777739,69.856377 C117.617823,78.9472754 119.536809,85.8850663 123.534695,90.6697496 C127.532582,95.454433 133.849243,97.9265194 142.484678,98.0860088 Z" transform="translate(142.6046, 63.9951) rotate(180) translate(-142.6046, -63.9951)" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function MetaCell({
  label,
  primary,
  secondary,
}: {
  label: string;
  primary: string | null | undefined;
  secondary: string | null | undefined;
}) {
  if (!primary && !secondary) {
    return (
      <div className="min-w-0">
        <div className="font-mono text-[9.5px] font-semibold uppercase tracking-[0.14em] text-zinc-500">
          {label}
        </div>
        <div className="mt-2 text-sm text-zinc-500">—</div>
      </div>
    );
  }
  return (
    <div className="min-w-0">
      <div className="font-mono text-[9.5px] font-semibold uppercase tracking-[0.14em] text-zinc-500">
        {label}
      </div>
      {primary && (
        <div className="mt-2 break-words text-sm font-semibold text-white">{primary}</div>
      )}
      {secondary && (
        <div className="mt-1 break-words text-[11.5px] text-zinc-400">{secondary}</div>
      )}
    </div>
  );
}

export function SectionDivider({
  num,
  label,
  sectionWord,
  clientCompany,
}: {
  num: string;
  label: string;
  sectionWord: string;
  clientCompany?: string | null;
}) {
  // Section 01 is client-specific (challenges) and reads better when prefixed
  // with the client's company name. Everything beyond is platform content and
  // stays generic.
  const showClient = clientCompany && num === "01";
  const fullLabel = showClient ? `${clientCompany} ${label}` : label;
  return (
    <div className="flex items-end gap-3 border-b border-brand-rule pb-5 pt-8 sm:gap-4 sm:pb-6 sm:pt-10">
      <div
        className="font-display text-5xl font-extrabold leading-[0.85] brand-gradient-text sm:text-7xl"
        style={{ letterSpacing: "-0.045em" }}
      >
        {num}
      </div>
      <div className="min-w-0 pb-1 sm:pb-2">
        <div className="font-mono text-[10.5px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
          {sectionWord} {num}
        </div>
        <div className="mt-1 text-sm font-bold tracking-display text-foreground sm:text-base">
          {fullLabel}
        </div>
      </div>
    </div>
  );
}

export function formatEur(cents: number) {
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
